import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

export interface RegistrationOnboardingGuard {
  ready: boolean;
  userId: string | null;
  orgId: string | null;
}

/**
 * Guard leggera per gli step post-account della registrazione (6-9:
 * discovery/connect/modules/team). Richiede sessione autenticata + org
 * assegnata (register-complete già eseguito); altrimenti redirect a /login.
 * NON usa useAuth(): queste route sono fuori da ProtectedRoute e il profilo
 * può non essere ancora nel context (org assegnata a metà flusso).
 */
export function useRegistrationOnboardingGuard(): RegistrationOnboardingGuard {
  const navigate = useNavigate();
  const [state, setState] = useState<RegistrationOnboardingGuard>({ ready: false, userId: null, orgId: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (cancelled) return;
      if (!session) { navigate('/login'); return; }
      const { data: profile } = await supabase
        .from('user_profiles')
        .select('organization_id')
        .eq('id', session.user.id)
        .single();
      if (cancelled) return;
      if (!profile?.organization_id) { navigate('/login'); return; }
      setState({ ready: true, userId: session.user.id, orgId: profile.organization_id });
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return state;
}
